import { render } from "./Beams.vue?vue&type=template&id=96903ab8"
import script from "./Beams.vue?vue&type=script&lang=js"
export * from "./Beams.vue?vue&type=script&lang=js"

import "./Beams.vue?vue&type=style&index=0&id=96903ab8&lang=css"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.27_vue@3.5.27_webpack@5.105.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__